import { useContext } from "react";
import {
  ViewActionsSlotContext,
  ViewActionsSlotSetterContext,
} from "../contexts/view_actions/context";

/** The top-bar slot node to portal view actions into (null until mounted). */
export const useViewActionsSlot = (): HTMLElement | null =>
  useContext(ViewActionsSlotContext);

/** Stable setter to register the top-bar slot node; use as a ref callback. */
export const useViewActionsSlotRef = (): ((el: HTMLElement | null) => void) =>
  useContext(ViewActionsSlotSetterContext);
